import { useAuth } from '../context/AuthContext';
import { useTeamAgents } from '../hooks/useTeamAgents';

// Manager-only "filter by salesman" dropdown. Renders nothing for non-managers.
// value = '' (All team) or an agent uid; calls onChange(uid). Shared by My Day +
// Leads & Pipeline (T-U3-006 / T-U3-007). Filtering is by lead.ownerUid.
export default function AgentFilter({ value, onChange }) {
  const { role } = useAuth();
  const agents = useTeamAgents();
  if (role !== 'manager') return null;
  return (
    <select className="chip-select" value={value} onChange={(e) => onChange(e.target.value)} aria-label="Filter by salesman">
      <option value="">All team</option>
      {agents.map((a) => <option key={a.uid} value={a.uid}>{a.name}</option>)}
    </select>
  );
}
